module.exports = __webpack_public_path__ + "dcfcae3812b6b04fd4ac714b62584268.jpg";